import React from 'react';
import { createRoot } from 'react-dom/client';
import injectUser from 'lib/inject-user';
import App from './app';
import WithApollo from './components/with-apollo';

const Root = () => <WithApollo>{injectUser(App)}</WithApollo>;

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<Root />);
